// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Lry7","log":"ModalInventoryLogs_log__3ohrH","date":"ModalInventoryLogs_date__2XzsL","userName":"ModalInventoryLogs_userName__3uRCD"};